(function () {
  const modal = document.getElementById("manualLightbox");
  if (!modal) return;

  const img = modal.querySelector(".manual-lightbox__img");
  const closeEls = modal.querySelectorAll("[data-manual-close]");

  function openManual(url) {
    img.src = url;
    modal.hidden = false;
    document.documentElement.classList.add("overflow-hidden");
  }

  function closeManual() {
    modal.hidden = true;
    img.removeAttribute("src");
    document.documentElement.classList.remove("overflow-hidden");
  }

  document.addEventListener("click", (e) => {
    const trigger = e.target.closest("[data-manual-image]");
    if (trigger) {
      e.preventDefault();
      openManual(trigger.getAttribute("data-manual-image"));
      return;
    }

    if (e.target.closest("[data-manual-close]")) {
      e.preventDefault();
      closeManual();
    }
  });

  document.addEventListener("keydown", (e) => {
    if (!modal.hidden && e.key === "Escape") closeManual();
  });
})();
